<template>
  <div class="substitute-dialog">
    <component
      :is="embedded ? 'div' : 'el-dialog'"
      title="员工换人"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      :close-on-click-modal="false">
      
      <div class="substitute-container" v-loading="loading">
        <!-- 到期提醒 -->
        <el-alert
          v-if="showAlert"
          title="您的保单即将在明天到期，批改无法生效，请您注意续保！有任何问题请及时联系您的保险顾问！"
          type="warning"
          show-icon
          :closable="false"
          style="margin-bottom: 20px;">
        </el-alert>
        
        <!-- 员工信息表格 -->
        <div class="employee-section">
          <div class="section-header">
            <h3 class="section-title">员工信息</h3>
          </div>
          
          <el-table
            :data="employeeList"
            border
            stripe
            style="width: 100%"
            class="employee-table">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="" width="60" align="center">
              <template slot-scope="scope">
                <el-checkbox 
                  v-if="!scope.row.sts"
                  v-model="scope.row.check"
                  @change="handleCheckChange(scope.$index)">
                </el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="姓名" width="150" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  placeholder="请输入姓名"
                  :disabled="scope.row.sts !== 'add'"
                  :class="{ 'highlight-error': scope.row.is_highlight }"
                  @blur="validateEmployee(scope.row)"
                  size="small">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="身份证号" width="200" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.idcard"
                  placeholder="请输入身份证号"
                  :disabled="scope.row.sts !== 'add'"
                  :class="{ 'highlight-error': scope.row.is_highlight }"
                  @blur="validateEmployee(scope.row)"
                  size="small">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="工作类型" align="center">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.type" :disabled="true" size="small">
                  <el-radio :label="1">搬运工人</el-radio>
                  <el-radio :label="4">司机押运</el-radio>
                  <el-radio :label="2">文员内勤</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <!-- 文件上传区域 -->
        <div class="upload-section">
          <h3 class="section-title">上传批改申请</h3>
          
          <div class="upload-area">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :accept="getAcceptTypes()"
              name="fileVal"
              multiple>
              <el-button size="small" type="primary">上传批改申请</el-button>
              <div slot="tip" class="el-upload__tip">
                支持{{ getAcceptTypes() }}格式文件，单个文件不超过10MB
              </div>
            </el-upload>
            
            <!-- 文件预览列表 -->
            <div class="file-preview-list" v-if="uploadedFiles.length > 0">
              <div class="file-item" v-for="(file, index) in uploadedFiles" :key="index">
                <div class="file-preview">
                  <img v-if="isImageFile(file)" :src="file" alt="预览图" class="preview-image" @click="previewFile(file)">
                  <div v-else class="file-icon" @click="previewFile(file)">
                    <i class="el-icon-document"></i>
                    <span>{{ getFileName(file) }}</span>
                  </div>
                </div>
                <el-button 
                  type="danger" 
                  size="mini" 
                  icon="el-icon-delete"
                  @click="removeFile(index)"
                  class="delete-btn">
                  删除
                </el-button>
              </div>
            </div>
          </div>

        </div>


      </div>

      <div v-if="embedded" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
          :loading="submitLoading"
          :disabled="!canSave">
          {{ submitLoading ? '保存中' : '保存' }}
        </el-button>
      </div>

      <div v-else slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button 
          type="primary" 
          @click="handleSubmit"
          :loading="submitLoading"
          :disabled="!canSave">
          {{ submitLoading ? '保存中' : '保存' }}
        </el-button>
      </div>

      <!-- 图片预览对话框 -->
      <el-dialog
        title="图片预览"
        :visible.sync="previewVisible"
        width="60%">
        <img :src="previewImageUrl" style="width: 100%" alt="预览图">
      </el-dialog>
    </component>
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { ygbOrderInfo, ygbOrderChangeEmployee, checkBatchIdcard } from '@/api/member.js'
import { uploadFile } from '@/api/product.js'

export default {
  name: 'Substitute',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      showAlert: false,
      formData: {
        id: '',
        effect_date: '',
        expire_date: ''
      },
      employeeList: [],
      uploadedFiles: [],
      fileList: [],
      previewVisible: false,
      previewImageUrl: '',
      
      // 上传配置
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.jubao56.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + this.$store.getters.token,
        'AppKey': 'BpLnfgDs'
      }
    }
  },
  computed: {
    canSave() {
      return this.employeeList.some(emp => emp.check && emp.name && emp.idcard)
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  mounted() {
    if (this.visible) {
      this.initFormData()
    }
  },
  methods: {
    formatDate,
    formatMoney,
    
    async initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        // 先设置基本信息
        this.formData = {
          id: this.rowData.id,
          effect_date: this.rowData.effect_date || '',
          expire_date: this.rowData.expire_date || ''
        }
        
        // 获取完整的订单信息（包括员工列表）
        await this.getOrderInfo()
      }
    },

    initEmployeeList() {
      // 初始化员工列表，添加一个空的员工记录
      this.employeeList = [
        {
          name: '',
          idcard: '',
          type: 1,
          check: false,
          sts: 'add',
          is_highlight: false
        }
      ]
    },

    // 校验身份证号码
    async checkIdcard(employeeList) {
      const idList = employeeList.map(item => ({
        name: (item.name || '').replace(/\s+/g, ''),
        id_card: (item.id_card || '').replace(/\s+/g, '')
      }))

      try {
        const response = await checkBatchIdcard({
          employee_list: idList
        })
        
        if (response.err_code === 0) {
          return 0
        } else {
          let str = ''
          if (response.errMsg && response.errMsg.length > 0) {
            response.errMsg.forEach(item => {
              str += item.name + '的' + item.error_message
            })
          }
          this.$message.error(str + "请您仔细核对后，重新填写正确的身份证号码！")
          return response.err_code
        }
      } catch (error) {
        console.error('身份证校验失败:', error)
        this.$message.error('身份证校验失败')
        return -1
      }
    },

    validateEmployee(employee) {
      // 验证员工信息，检查年龄等
      employee.is_highlight = false
      
      if (employee.idcard && employee.idcard.length === 18) {
        const birthYear = parseInt(employee.idcard.substr(6, 4))
        const currentYear = new Date().getFullYear()
        const age = currentYear - birthYear
        
        // 年龄限制为18-65岁
        if (age < 18 || age > 65) {
          employee.is_highlight = true
          this.$message.warning(`${employee.name || '该员工'}年龄不在18-65岁范围内`)
        }
      }
      
      // 验证身份证号格式
      if (employee.idcard && !/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(employee.idcard)) {
        employee.is_highlight = true
        this.$message.warning('身份证号格式不正确')
      }
    },

    handleCheckChange() {
      // 处理复选框变化，实现选中时插入新行的功能
      this.employeeList.forEach((item, idx) => {
        if (item.check) {
          // 如果是最后一行，直接在后面添加新行
          if (idx === this.employeeList.length - 1) {
            this.employeeList.splice(idx + 1, 0, {
              id: item.id,
              sts: "add",
              name: "",
              idcard: "",
              type: item.type,
              check: false,
              is_highlight: false
            })
          } else {
            // 如果下一行不是新增状态，则插入新行
            if (!this.employeeList[idx + 1].sts) {
              this.employeeList.splice(idx + 1, 0, {
                id: item.id,
                sts: "add", 
                name: "",
                idcard: "",
                type: item.type,
                check: false,
                is_highlight: false
              })
            }
          }
        } else {
          // 如果取消选中，且当前行是新增状态，且前一行未选中，则删除当前行
          if (item.sts && idx > 0 && !this.employeeList[idx - 1].check && !this.employeeList[idx - 1].sts) {
            this.employeeList.splice(idx, 1)
          }
        }
      })
    },

    getAcceptTypes() {
      return '.pdf,.jpg,.png,.jpeg,.doc,.docx,.xlsx,.xls'
    },

    beforeUpload(file) {
      const acceptTypes = this.getAcceptTypes().split(',')
      const fileExt = '.' + file.name.split('.').pop().toLowerCase()
      
      if (!acceptTypes.includes(fileExt)) {
        this.$message.error(`只支持${this.getAcceptTypes()}格式的文件`)
        return false
      }
      
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }
      
      return true
    },

    handleUploadSuccess(response) {
      if (response.err_code === 0) {
        this.uploadedFiles.push(response.data)
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.err_msg || '文件上传失败')
      }
    },

    async handleFileUpload(file) {
      // 文件大小限制 (10MB)
      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      // 文件类型限制
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只支持图片、PDF、Word文档格式')
        return false
      }

      try {
        // 创建FormData对象
        const formData = new FormData()
        formData.append('fileVal', file)
        
        // 调用上传API
        const response = await uploadFile(formData)
        
        if (response && response.err_code === 0) {
          const uploadedFile = {
            id: Date.now(),
            name: file.name,
            url: response.data.url,
            type: file.type,
            size: file.size,
            file: file
          }
          
          this.uploadedFiles.push(uploadedFile)
          this.fileList.push({
            name: file.name,
            url: response.data.url
          })
          
          this.$message.success('文件上传成功')
        } else {
          this.$message.error(response.err_msg || '文件上传失败')
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败')
      }
      
      return false // 阻止默认上传行为
    },

    handleUploadError() {
      this.$message.error('文件上传失败')
    },

    async handleSubmit() {
      this.submitLoading = false
      
      // 获取选中的员工列表
      const list = []
      const idList = []
      
      this.employeeList.forEach((item) => {
        item.name = (item.name || '').replace(/\s+/g, '') // 去掉全部空格
        if (item.sts) {
          list.push(item)
          idList.push({
            name: (item.name || '').replace(/\s+/g, ''),
            id_card: (item.idcard || '').replace(/\s+/g, '')
          })
        }
      })

      // 检查是否有换人信息
      if (list.length === 0) {
        this.$message.warning('请填写换人信息')
        this.submitLoading = true
        return false
      }

      // 检查基本信息
      let tip = null
      list.forEach((L) => {
        if (!L.name) return (tip = "请完善人员姓名")
        if (!L.idcard) return (tip = "请完善人员身份证号")
      })

      // 校验身份证
      const ids = await this.checkIdcard(idList)
      if (ids !== 0) {
        this.submitLoading = true
        return false
      }
      
      if (tip) {
        this.$message.warning(tip)
        this.submitLoading = true
        return false
      }

      this.submitLoading = true
      
      try {
        const params = {
          order_id: Number(this.formData.id),
          employee_list: list.map(emp => ({
            id: emp.id, // 被换人的id
            name: (emp.name || '').replace(/\s+/g, ''), // 换入人的姓名
            idcard: (emp.idcard || '').replace(/\s+/g, ''), // 换入人的身份证
            type: emp.type,
            sts: 'add'
          }))
        }

        // 如果有上传文件，添加到参数中
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
          params.correct_url = this.uploadedFiles
        }
        
        // 调用换人API
        const response = await ygbOrderChangeEmployee(params)
        
        if (response && response.err_code === 0) {
          this.$message.success('换人操作成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(response.err_msg || '换人操作失败')
        }
      } catch (error) {
        console.log('换人操作失败');
      } finally {
        this.submitLoading = false
      }
    },

    handleClose() {
      if (this.embedded) {
        this.resetData()
        this.$emit('cancel')
        return
      }
      this.dialogVisible = false
      this.resetData()
    },

    // 获取订单详细信息
    async getOrderInfo() {
      if (!this.formData.id) return
      
      this.loading = true
      try {
        const response = await ygbOrderInfo({
          id: this.formData.id,
          platform_type: 8
        })
        
        if (response && response.err_code === 0 && response.order) {
          const order = response.order
          
          // 更新表单数据
          this.formData = {
            ...this.formData,
            effect_date: order.effect_date || '',
            expire_date: order.expire_date || ''
          }
          
          // 初始化员工列表 - 显示现有员工
          if (order.employee_list && order.employee_list.length > 0) {
            const activeEmployees = order.employee_list.filter(emp => emp.status === 1)
            this.employeeList = activeEmployees.map(emp => ({
              name: emp.name || '',
              idcard: emp.idcard || emp.id_card || '',
              type: emp.type || 1,
              check: false,
              sts: '', // 现有员工，不是新增
              is_highlight: false,
              id: emp.id
            }))
            
            // 如果没有现有员工，添加一个空的新增员工
            if (this.employeeList.length === 0) {
              this.initEmployeeList()
            }
          } else {
            this.initEmployeeList()
          }
          
          // 检查保单是否即将到期
          if (order.expire_date) {
            const expireTime = new Date(order.expire_date).getTime()
            const now = new Date().getTime()
            this.showAlert = (now + 86400000) > expireTime // 提前一天提醒
          }
        } else {
          this.$message.error(response.err_msg || '获取订单信息失败')
        }
      } catch (error) {
        console.error('获取订单信息失败:', error)
        this.$message.error('获取订单信息失败')
      } finally {
        this.loading = false
      }
    },

    // 判断是否为图片文件
    isImageFile(file) {
      if (typeof file === 'string') {
        return /\.(jpg|jpeg|png|gif)$/i.test(file)
      }
      return file && file.type && file.type.startsWith('image/')
    },

    // 获取文件名
    getFileName(file) {
      if (typeof file === 'string') {
        return file.split('/').pop()
      }
      return file.name || '未知文件'
    },

    // 预览文件
    previewFile(file) {
      if (this.isImageFile(file)) {
        this.previewImageUrl = typeof file === 'string' ? file : file.url
        this.previewVisible = true
      } else {
        // 对于非图片文件，直接打开
        const url = typeof file === 'string' ? file : file.url
        window.open(url, '_blank')
      }
    },

    // 删除文件
    removeFile(index) {
      this.uploadedFiles.splice(index, 1)
      this.fileList.splice(index, 1)
    },

    resetData() {
      this.employeeList = []
      this.uploadedFiles = []
      this.fileList = []
      this.formData = {
        id: '',
        effect_date: '',
        expire_date: ''
      }
      this.submitLoading = false
      this.showAlert = false
      this.previewVisible = false
      this.previewImageUrl = ''
    }
  }
}
</script>

<style lang="less" scoped>
.substitute-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .substitute-container {
    padding: 0;
  }

  .order-info-section {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      
      .label {
        font-weight: 600;
        color: #606266;
        margin-right: 8px;
        min-width: 80px;
      }
      
      .value {
        color: #303133;
      }
    }
  }

  .employee-section {
    margin-bottom: 30px;
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin: 0;
      color: #333;
    }
  }

  .employee-table {
    margin-bottom: 20px;
    
    /deep/ .highlight-error {
      .el-input__inner {
        border-color: #f56c6c !important;
        background-color: #fef0f0 !important;
      }
    }
  }

  .upload-section {
    margin-bottom: 20px;
    
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }
  }

  .upload-area {
    margin-bottom: 20px;
  }

  .file-preview-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 15px;
  }

  .file-item {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    background: #f9f9f9;
    width: 120px;
  }

  .file-preview {
    margin-bottom: 10px;
  }

  .preview-image {
    width: 100px;
    height: 60px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 4px;
    display: block;
  }

  .file-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    width: 100px;
    text-align: center;
    
    i {
      font-size: 24px;
      color: #409eff;
      margin-bottom: 5px;
    }
    
    span {
      font-size: 12px;
      color: #666;
      word-break: break-all;
      line-height: 1.2;
    }
  }

  .delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 2px 4px;
    min-height: auto;
  }

  .download-section {
    margin: 15px 0;
  }

  .download-link {
    color: #8B4513;
    font-size: 14px;
    text-decoration: underline;
    
    &:hover {
      color: #5a2d0c;
    }
  }

  .notice-section {
    margin-top: 20px;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 4px;
    border-left: 4px solid #e6a23c;
  }

  .notice-content {
    p {
      margin: 8px 0;
      line-height: 1.6;
      font-size: 14px;
      color: #606266;
    }
    
    .warning-text {
      color: #f56c6c !important;
      font-weight: 600;
    }
  }



  .dialog-footer {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-row {
    margin-bottom: 10px;
  }

  // Element UI 组件样式覆盖
  /deep/ .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
  }

  /deep/ .el-table th {
    background-color: #fafafa;
  }

  /deep/ .el-radio-group {
    .el-radio {
      margin-right: 15px;
      
      &:last-child {
        margin-right: 0;
      }
    }
  }

  /deep/ .el-alert {
    margin-bottom: 20px;
  }
}
</style>

<style lang="less" scoped>
.substitute-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .substitute-container {
    padding: 0;
  }

  .order-info-section {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      
      .label {
        font-weight: 600;
        color: #606266;
        margin-right: 8px;
        min-width: 80px;
      }
      
      .value {
        color: #303133;
      }
    }
  }

  .employee-section {
    margin-bottom: 30px;
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin: 0;
      color: #333;
    }
  }

  .employee-table {
    margin-bottom: 20px;
    
    /deep/ .highlight-error {
      .el-input__inner {
        border-color: #f56c6c !important;
        background-color: #fef0f0 !important;
      }
    }
  }

  .upload-section {
    margin-bottom: 20px;
    
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }
  }

  .upload-area {
    margin-bottom: 20px;
  }

  .file-preview-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 15px;
  }

  .file-item {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    background: #f9f9f9;
    width: 120px;
  }

  .file-preview {
    margin-bottom: 10px;
  }

  .preview-image {
    width: 100px;
    height: 60px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 4px;
    display: block;
  }

  .file-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    width: 100px;
    text-align: center;
    
    i {
      font-size: 24px;
      color: #409eff;
      margin-bottom: 5px;
    }
    
    span {
      font-size: 12px;
      color: #666;
      word-break: break-all;
      line-height: 1.2;
    }
  }

  .delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 2px 4px;
    min-height: auto;
  }

  .download-section {
    margin: 15px 0;
  }

  .download-link {
    color: #8B4513;
    font-size: 14px;
    text-decoration: underline;
    
    &:hover {
      color: #5a2d0c;
    }
  }

  .notice-section {
    margin-top: 20px;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 4px;
    border-left: 4px solid #e6a23c;
  }

  .notice-content {
    p {
      margin: 8px 0;
      line-height: 1.6;
      font-size: 14px;
      color: #606266;
    }
    
    .warning-text {
      color: #f56c6c !important;
      font-weight: 600;
    }
  }



  .dialog-footer {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-row {
    margin-bottom: 10px;
  }

  // Element UI 组件样式覆盖
  /deep/ .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
  }

  /deep/ .el-table th {
    background-color: #fafafa;
  }

  /deep/ .el-radio-group {
    .el-radio {
      margin-right: 15px;
      
      &:last-child {
        margin-right: 0;
      }
    }
  }

  /deep/ .el-alert {
    margin-bottom: 20px;
  }
}
</style>
